/* eslint-disable */
import * as d3Selection from 'd3-selection';
import * as d3Geo from 'd3-geo';
import * as d3Zoom from 'd3-zoom';
import View from './view';
import MapView from './mapView';
import Utils from '../utils';

export default class PulloutView extends MapView {
  constructor(controller, container, config) {
    	super(controller, container, config);

    	// required
      this.modelForPullout = this.config.modelForPullout;
      this.projection = this.config.projection;
      this.dimensions = this.config.dimensions;
      this.svgClassName = 'map__pullout-view';
      this.baseFeatureClass = 'pullout-view__feature';
      this.baseFeatureGroupClass = 'pullout-view__feature-group';
      this.width = this.dimensions[0] / 5;
      this.height = this.width / this.config.aspectRatio;

      this.path = d3Geo.geoPath().projection(this.projection);
    }

    render() {
      this.renderContainer();
      this.renderFeatures();
    }

    renderContainer() {
      this.removeNode();

      this.svg = d3Selection
        .select(this.container)
          .append('svg')
          .attr('class', this.svgClassName)
          .attr('role', 'presentation')
          .attr('preserveAspectRatio', 'xMidYMid meet')
          .attr('width', this.width)
          .attr('height', this.height)
          .attr('viewBox', `0 0 ${this.dimensions[0]} ${this.dimensions[1]}`);

      this.group = this.svg.append('g')
        .attr('class', this.baseFeatureGroupClass);
    }

    renderFeatures() {
        this.destroyChildren();
        for (let f = 0; f < this.modelForPullout.features.length; f++) {
            const selection = this.group.append('g')
                .datum(this.modelForPullout.features[f])
                    .append('path')
                    .attr('d', this.path)
                    .attr('class', (d) => this.getFeatureClassName(d));

                selection
                    .on('click', (d) => {
                        this.handleModelWithSingleFeatureClick(d);
                    });

                selection
                    .on('mousemove', (d, i, s) => {
                        const position = d3Selection.mouse(this.container);
                        this.handleFeatureMouseMove(position);
                    });

                selection
                    .on('mouseover', (d, i, s) => {
                        this.handleFeatureHoverOn(d, i, s);
                    });

                selection
                    .on('mouseout', (d, i, s) => {
                        this.handleFeatureHoverOff(d, i, s);
                    });
        }
    }

    renderData(key, colorScale) {
        const features = this.modelForPullout.features;
        const dataValueKey = key;
        const colour = colorScale;

        for (let f = 0; f < features.length; f++) {
            this.group.selectAll(`.${this.getFeatureIdClass(features[f])}`)
                .datum(features[f])
                .classed(`${this.baseFeatureClass}--no-data`, (d) => {
                  return !this.featureHasData(d, dataValueKey);
                })
                .attr('fill', (d) => {
                    return colour(d.properties.values[dataValueKey])
                });
        }
    }

    getFeatureIdClass(feature) {
        const id = feature.id;
        return `${this.baseFeatureClass}--${id}`;
    }

    getFeatureClassName(feature) {
        const id = feature.id;
        const idClass = this.getFeatureIdClass(feature);
        const className = `${this.baseFeatureClass} ${idClass}`;

        return className;
    }

    getFeatureClassName(feature) {
        const id = feature.id;
        const idClass = `${this.baseFeatureClass}--${id}`;
        const className = `${this.baseFeatureClass} ${idClass}`;

        return className;
    }

    showPullout(bool) {
      this.pulloutReference
          .select('.map__pullout-view')
          .classed('map__pullout-view--inactive', bool);
    }

    handleModelWithSingleFeatureClick(d) {
      this.emitFeatureFocus(d);
    }

    handleFeatureHoverOn(d, i, s) {
      const datum = d;
      const node = s[i];

      this.emit('hover-feature', {
          feature: datum,
          node: node,
      });
    }

    handleFeatureHoverOff(d, i, s) {
      const datum = d;
      const node = s[i];

      this.emit('unhover-feature', {
          feature: datum,
          node: node,
      });
    }
}
